// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"45317f6c7f2721859acd","655":"197c208598cdcfada958"}[chunkId] + ".js";
};